import { createTheme } from '@mui/material/styles'
import { defaultFont } from 'themes'

export const calendarDatePickerTheme = createTheme({
  palette: {
    primary: {
      main: '#0053FF',
    },
  },
  typography: {
    fontFamily: defaultFont,
  },
})
